import { render, staticRenderFns } from "./GlobalWarningModal.vue?vue&type=template&id=915f42a6&scoped=true"
import script from "./GlobalWarningModal.vue?vue&type=script&lang=js"
export * from "./GlobalWarningModal.vue?vue&type=script&lang=js"
import style0 from "./GlobalWarningModal.vue?vue&type=style&index=0&id=915f42a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915f42a6",
  null
  
)

export default component.exports